import styled from 'styled-components';
import SelectTileOriginal from '../SelectTile/SelectTile';

export const SelectTile = styled(SelectTileOriginal)``;

const SelectTileGroup = styled.div`
  display: grid;
  grid-template-columns: ${({ tiles }) => {
    const ONE_ROW_MAX = 3;
    const cols = tiles > ONE_ROW_MAX ? ONE_ROW_MAX : tiles;
    return `repeat(${cols}, 1fr [col])`;
  }};
  grid-template-rows: [row] auto;
  grid-gap: 8px;

  /* border radius styling for 2 row grid */
`;

export default SelectTileGroup;
